import swal from 'sweetalert2'
import { Table, TableColumn, Select, Option, Input, Button } from 'element-ui'
import { Pagination as LPagination, Switch as LSwitch } from '@/components/index'
import Fuse from 'fuse.js'
import ResourceSvc from '@/services/resource.svc.js';
const svc = new ResourceSvc();

export default {
    name: 'AdminCourseTypes',
    components: {
        LPagination,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Input.name]: Input,
        [Button.name]: Button,
        LSwitch
    },
    computed: {
        pagedData() {
            return this.tableData.slice(this.from, this.to)
        },
        queriedData() {
            this.setFusedSearch();
            let result = this.tableData
            if (this.searchQuery !== '') {
                result = this.fuseSearch.search(this.searchQuery)
                this.pagination.total = result.length
            }
            return result.slice(this.from, this.to)
        },
        to() {
            let highBound = this.from + this.pagination.perPage
            if (this.total < highBound) {
                highBound = this.total
            }
            return highBound
        },
        from() {
            return this.pagination.perPage * (this.pagination.currentPage - 1)
        },
        total() {
            this.pagination.total = this.tableData.length
            return this.tableData.length
        }
    },
    data() {
        return {
            pagination: {
                perPage: 5,
                currentPage: 1,
                perPageOptions: [5, 10, 25, 50],
                total: 0
            },
            searchQuery: '',
            propsToSearch: ['name'],
            tableColumns: [
                {
                    prop: 'name',
                    label: 'Name',
                    minWidth: 300
                },
                {
                    prop: 'isActiveString',
                    label: 'Is active',
                    minWidth: 60
                },
                {
                    prop: 'countUsed',
                    label: 'Count courses',
                    minWidth: 70
                }
            ],
            tableData: [],
            fuseSearch: null,
            isEditMode: false,
            isCreateMode: false,
            currentTypeId: 0,
            currentTypeName: '',
            currentTypeIsActive: false,
            currentTypeCountUsed: 0
        }
    },
    methods: {
        saveAddOrEdit() {
            var data = {
                id: this.currentTypeId,
                name: this.currentTypeName,
                isActive: this.currentTypeIsActive,
                countUsed: this.currentCountUsed
            }
            if (this.currentTypeId == 0) {
                svc.addCourseType(data).then(resp => {
                    this.loadDataWithUpdateTabs();
                }, resp => {
                    //add catch
                });
            } else {
                svc.updateCourseType(data).then(resp => {
                    this.loadDataWithUpdateTabs();
                }, resp => {
                    //add catch
                });
            }
        },
        setEditMode(index, row) {
            this.currentTypeId = row.id;
            this.currentTypeName = row.name;
            this.currentTypeIsActive = row.isActive;
            this.currentTypeCountUsed = row.countUsed;
            this.isEditMode = true;
        },
        deleteRecord(index, row) {
            var self = this;
            if (row.countUsed > 0) {
                this.showDeleteCountUsedRecords();
                return;
            }
            swal({
                title: 'Warning!',
                text: 'You really want to delete this record?',
                type: 'warning',
                showCancelButton: true,
                confirmButtonClass: 'btn btn-success btn-fill',
                cancelButtonClass: 'btn btn-danger btn-fill',
                confirmButtonText: 'Yes, delete it!',
                buttonsStyling: false
            }).then(function (result) {
                if (result.value == true) {
                    self.sendDeleteRecordRequest(row.id)
                }
            });
        },
        sendDeleteRecordRequest(id) {
            var that = this;
            svc.deleteCourseType(id).then(function (response) {
                var result = response.body;
                if (!result.isSuccess) {
                    that.$notify({
                        title:"Error while deleting!",
                        message:'Explanation:' + result.message,
                        type: 'danger'
                    });
                    return;
                }
                that.$parent.$parent.$children.forEach(function (child) {
                    if (child.$children[0] && child.$children[0].queriedData && typeof child.$children[0].queriedData === 'function') {
                        child.$children[0].updateData();
                    }
                });
                let indexToDelete = that.tableData.findIndex((tableRow) => tableRow.id === result.recordId);
                if (indexToDelete >= 0) {
                    that.tableData.splice(indexToDelete, 1);
                }
                this.$notify({
                    title: "Success!",
                    message: 'Type has been deleted.',
                    type: 'success'
                });
            }).catch(function () { });
        },
        showDeleteCountUsedRecords() {
            this.$notify({
                title: "Warning!",
                message: 'This type can\'t be deleted until will be deleted all related courses!',
                type: 'warning '
            });            
        },
        loadData() {
            var that = this;
            svc.getCourseTypes().then(function (resp) {
                if (!resp.body) {
                    window.location.href = "/";
                    return;
                }
                that.tableData = resp.body.filter(function (type) { return type.id != 0; });
            });
            if (this.isEditMode) {
                this.isEditMode = false;
                this.notifySuccess("Record updated!");
            } else if (this.isCreateMode) {
                this.isCreateMode = false;
                this.notifySuccess("Record added!");
            }
        },
        setAddMode() {
            this.isCreateMode = true;
            this.currentTypeId = 0;
            this.currentTypeName = '';
            this.currentTypeIsActive = false;
            this.currentTypeCountUsed = 0;
        },
        undoAnyMode() {
            this.isCreateMode = false;
            this.isEditMode = false;
        },
        setFusedSearch() {
            this.fuseSearch = new Fuse(this.tableData, { keys: ['name'] });
        },
        notifySuccess(message) {
            if (!message) {
                message = 'Operation success!';
            }
            this.$notify({
                title: "Success!",
                message:  message,
                type: 'success'
            });            
        },
        loadDataWithUpdateTabs() {
            this.$parent.$parent.$children.forEach(function (child) {
                if (child.$children[0] && child.$children[0].queriedData && typeof child.$children[0].queriedData === 'function') {
                    child.$children[0].updateData();
                }
            });
            this.loadData();
        }
    },
    mounted() {
        this.setFusedSearch();
    },
    created() {
        this.loadData();
    }
}


// WEBPACK FOOTER //
// ./src/components/admin/courses/course-types/course-types.js